export const navLinks = [
  { label: 'Home', path: '/', icon: true },
  { label: 'Toddlers', path: '/toddlers' },
  { label: 'Preschool – Grade R', path: '/preschool' },
  { label: 'Curriculum', path: '/curriculum' },
  { label: 'Extra Murals', path: '/extra-murals' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Team', path: '/team' },
  { label: 'Policies', path: '/policies' },
  { label: 'About Montessori', path: '/about-montessori' },
  { label: 'Montessori vs Mainstream', path: '/montessori-vs-mainstream' },
  { label: 'Contact Us', path: '/contact' },
];

export const footerQuickLinksLeft = [
  { label: 'Toddlers (18m – 3y)', path: '/toddlers' },
  { label: 'Preschool (3 – 6y)', path: '/preschool' },
  { label: 'Curriculum', path: '/curriculum' },
  { label: 'Extra Murals', path: '/extra-murals' },
  { label: 'Team', path: '/team' },
];

export const footerQuickLinksRight = [
  { label: 'Policies', path: '/policies' },
  { label: 'About Montessori', path: '/about-montessori' },
  { label: 'Montessori vs Mainstream', path: '/montessori-vs-mainstream' },
  { label: 'Contact Us', path: '/contact' },
];

export const contactInfo = {
  email: 'admin@cvillemont.co.za',
  phone: '064 625 3713',
  address: '20 Kriek street, Carletonville 2499',
};
